import { Mask } from './Mask';
import { Player } from '../game/Player';
import { Game } from '../game/Game';

export class AresMask extends Mask {
  private game: Game;
  public onBreakAttempt: ((position: THREE.Vector3, direction: THREE.Vector3) => boolean) | null = null;
  
  constructor(player: Player, game: Game) {
    super(
      'Mask of Ares',
      'Break walls and push heavy objects',
      0xf44336, // Red
      player
    );
    
    this.game = game;
    this.maxAbilityDuration = 0.5; // Quick strike
    this.cooldownTime = 1; // Short cooldown
  }
  
  protected onActivate(): void {
    // Ares mask equipped
  }
  
  protected onDeactivate(): void {
    // Ares mask unequipped
  }
  
  protected onUpdate(_deltaTime: number): void {
    // Nothing special
  }
  
  protected onAbilityStart(): void {
    // Attempt to break nearby breakable wall
    this.attemptBreak();
  }
  
  protected onAbilityEnd(): void {
    // Strike finished
  }
  
  private attemptBreak(): void {
    if (this.onBreakAttempt) {
      const direction = new THREE.Vector3(0, 0, -1);
      direction.applyQuaternion(this.player.camera.quaternion);
      
      const success = this.onBreakAttempt(this.player.position.clone(), direction);
      
      if (success) {
        this.game.showHint('Wall destroyed!', 1500);
        // Could add screen shake here
      }
    }
  }
}

// Import THREE for types
import * as THREE from 'three';
